import FormWrapper from '@components/search/forms/FormWrapper'
import ServiceForm from '@components/search/forms/ServiceForm'
import { frontpageLinks } from '@components/search/formLinks'

const ServiceSearchpageForm = ({ query }) => {
    return (
        <FormWrapper
            Form={ServiceForm}
            formLinks={frontpageLinks}
            overrideDefaultValues={query}
            active={6}
            linksOnTop
        />
    )
}

export default ServiceSearchpageForm